// extracted by mini-css-extract-plugin
export default {"back":"ContactUsPage_back__JqoSL","dark":"ContactUsPage_dark__JjDNs","light":"ContactUsPage_light__SjgGo"};